import React from "react"
import { InputTextProps } from "~components/input-text/types"
import { InputTextBottomLine } from "~components/input-text"
import styled from '~/ui/styled'

interface SearchBarProps {
  inputSetting: Partial<InputTextProps>
}

const Container = styled.View`
  flex: 1;
`

const SearchBar: React.FC<SearchBarProps> = ({ inputSetting }) => {
  return (
    <Container>
      <InputTextBottomLine {...inputSetting} />
    </Container>
  )
}
export default SearchBar
